<template>
  <v-layout row justify-center>
   <v-navigation-drawer
      width="580"
      v-model="periodmodal"
      fixed
      right
      clippe
    >
    <v-btn flat small class="green-darken-text font-roboto" @click="periodmodal = false">
      <v-icon>close</v-icon>CLOSE
    </v-btn>
      <!-- <v-btn flat  icon @click="invoicemodal = false" class="green--text" dense>
        &nbsp;&nbsp;&nbsp;&nbsp;<v-icon>close</v-icon>
        close
      </v-btn> -->
      <v-spacer></v-spacer>
        <v-flex xs12>
          <p align="center" class="font-size-20-bold font-roboto">Period Detail</p>
        </v-flex>
        <v-layout>
          <v-flex xs12 md12 px-4>
            <span style="font-weight:bold;">Service</span> &emsp;&emsp;&emsp;
            <span style="color:#239026; font-weight:bold;">{{nameserviceSelected}}</span>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex xs12 md12 px-4>
            <span style="font-weight:bold;">Start Date</span> &emsp;&emsp;
            <span>{{formatDate(summarydetail.sv_period_start_date)}}</span>
          </v-flex>
          <!-- <v-flex md6 px-4 v-if="!mobileView">
            <span style="font-weight:bold;">End Date</span> &emsp;&emsp;
            <span>{{formatDate(summarydetail.sv_period_end_date)}}</span>
          </v-flex> -->
        </v-layout>
        <v-layout>
          <v-flex xs12 px-4>
            <span style="font-weight:bold;">End Date</span> &emsp;&emsp;&nbsp;&nbsp;
            <span>{{formatDate(summarydetail.sv_period_end_date)}}</span>
          </v-flex>
        </v-layout>
        <v-layout align-center justify-center row wrap>
          <!-- <v-flex xs11 py-4>
            <v-data-table
              :headers="tablelistheaders"
              :items="itemlistview"
              hide-actions
              class="elevation-1 font-roboto"
              id="tableDetail"
            >
              <template v-slot:items="props" >
                <tr >
                  <td data-label="No." >{{ props.index + 1}}</td>
                  <td data-label="Description" class="longtext">{{ props.item.services_type}}</td>
                  <td data-label="Amount" class="text-xs-right">{{ addCommas(props.item.sv_amount_exclude_vat.toFixed(2))}}</td>
                </tr>
              </template>
            </v-data-table>
          </v-flex> -->
          <v-layout align-center justify-end row wrap px-4>
            <v-flex xs10 py-3 px-4>
              <div class="font-size-14 font-roboto" align="right">
                <span>Total Amount (THB)</span> &nbsp;&nbsp;
                <br />
                <span>VAT (THB)</span> &nbsp;&nbsp;
                <br />
                <span v-if="summarydetail.wht_rate != null">Withholding Tax ({{summarydetail.wht_rate}}%)</span>
                <span v-else>Withholding Tax (0%)</span>
                <br />
                <span>Fines (THB)</span> &nbsp;&nbsp;
                <br />
                <strong>Grand Total (THB) &nbsp;&nbsp;</strong>
              </div>
            </v-flex>
            <v-flex xs2 py-4>
              <div class="font-size-14 font-roboto" align="right">
                <span>{{ this.addCommas(sub_total.toFixed(2)) }}</span>
                <br />
                <span>{{ this.addCommas(vat_amount.toFixed(2)) }}</span>
                <br />
                <span v-if="summarydetail.invoice_no">{{ this.addCommas((summarydetail.wht_amount).toFixed(2)) }}</span>
                <span v-else>0.00</span>
                <br />
                <span v-if="summarydetail.invoice_status !== 'Clear'">{{ this.addCommas(parseFloat(summarydetail.fines).toFixed(2)) }}</span>
                <span v-else>0.00</span>
                <br />
                <strong v-if="summarydetail.invoice_status !== 'Clear'">{{ this.addCommas((sub_total + vat_amount - summarydetail.wht_amount + parseFloat(summarydetail.fines)).toFixed(2)) }}</strong>
                <strong v-else>{{ this.addCommas((sub_total + vat_amount - summarydetail.wht_amount).toFixed(2)) }}</strong>
                <!-- <strong v-if="summarydetail.invoice_no">{{ this.addCommas(summarydetail.pay_amount.toFixed(2)) }}</strong>
                <strong v-else>{{ this.addCommas((sub_total + vat_amount + parseFloat(summarydetail.fines)).toFixed(2)) }}</strong> -->
              </div>
            </v-flex>
          </v-layout>
        </v-layout>
        <v-layout align-center justify-end row wrap px-5>
          <!-- :src="'data:image/jpeg;base64,'+currentEvidence.evidenceImg" -->
          <!-- <a :href="`data:application/pdf;base64,${fileEinvoice}`" download="file.pdf"> -->
          <!-- <a :href="'data:application/pdf;base64,'+ fileEinvoice" target="_blank" >huhu</a> -->
          <v-flex md2 xs4 v-if="summarydetail.invoice_no">
            <v-btn small color="#3A8300" class="white--text" style="text-transform:none; border-radius:10px;" @click="getE_invoice()"><v-icon small green>mdi-download</v-icon>&nbsp;e-invoice</v-btn>
          </v-flex>
          <v-flex xs1></v-flex>
           <v-flex md2 xs3>
            <v-btn small color="#3A8300" class="white--text" style="text-transform:none; border-radius:10px;" v-if="summarydetail.invoice_status != null && summarydetail.invoice_status != 'Open'" @click="getE_receipt()"><v-icon small>mdi-download</v-icon>&nbsp;e-Receipt</v-btn>
          </v-flex>
          <!-- <v-flex md2 xs3>
            <v-btn small color="#3A8300" class="white--text" style="text-transform:none; border-radius:10px;" @click="getE_invoice()"><v-icon small green>mdi-download</v-icon>&nbsp;e-invoice</v-btn>
          </v-flex> -->
        </v-layout>
        <v-flex pb-3></v-flex>
    </v-navigation-drawer>
    <form ref="paymentform" name="PostForm" method="POST" :action="paymenturl">
      <input name="access_token" type="hidden" :value="paymenttoken" />
    </form>
  </v-layout>
</template>

<script>
import { sync } from 'vuex-pathify'
import moment from 'moment'
moment.locale('en')
export default {
  data () {
    return {
      start_date: '',
      end_date: '',
      invoice_no: '',
      fileEinvoice: '',
      sub_total: 0.00,
      pay_amount: 0.00,
      vat_amount: 0.00,
      wht_amount: 0.00,
      wht_rate: '',
      svdetail: [],
      summarydetail: [],
      mobileView: false,
      dialogloader: true,
      notifications: false,
      sound: true,
      widgets: false,
      nameserviceSelected: '',
      invoicedatail: { item_list: [] },
      tablelistheaders: [
        { text: 'No.', value: 'index', sortable: false, align: 'center' },
        {
          text: 'Description',
          value: 'services_type',
          sortable: false,
          align: 'left'
        },
        {
          text: 'Amount (THB)',
          value: 'sv_amount_exclude_vat',
          sortable: false,
          align: 'right'
        }
      ],
      paymenttoken: ''
    }
  },
  methods: {
    formatDate (date) {
      return moment(date).format('DD MMMM YYYY')
    },
    async getE_receipt () {
      try {
        var { data: result } = await this.axios.post(process.env.VUE_APP_APIHOST + '/get_ereceipt',
          { invoice_no: this.invoice_no })
        if (result.status == 'OK') {
          var linkReceipt = result.pdfURL
          window.open(linkReceipt, '_blank')
        } else {
          alert('กำลังดำเนินการ กรุณาตรวจสอบในวันถัดไป')
        }
      } catch (error) {
        this.istableloading = false
        console.log(error.message)
      }
    },
    async getE_invoice () {
      try {
        if (this.currentsvnumber && this.currentstart_date && this.currentend_date) {
          var { data: data1 } = await this.axios.post(process.env.VUE_APP_APIHOST + '/get_einvoice', {
            invoiceno: this.invoice_no
          })
          if (data1.status == 'Not Found') {
            alert('กำลังดำเนินการ กรุณาตรวจสอบในวันถัดไป')
          } else {
            this.fileEinvoice = data1.File
            var objbuilder = ''
            objbuilder += ('<object width="100%" height="100%"      data="data:application/pdf;base64,')
            objbuilder += (this.fileEinvoice)
            objbuilder += ('" type="application/pdf">')
            objbuilder += ('<embed src="data:application/pdf;base64,')
            objbuilder += (this.fileEinvoice)
            objbuilder += ('" type="application/pdf" />')
            objbuilder += ('</object>')
            this.convertbase64(this.fileEinvoice, objbuilder)
            // var win = window.open("", '_blank')
            // var data = ''
            // data = '<html><body>' + objbuilder + '</body></html>'
            // win.document.write(data)
            // win.document.title = this.invoice_no;
          }
        }
      } catch (error) {
        this.istableloading = false
        console.log(error.message)
      }
    },
    convertbase64 (b64Data, objbuilder) {
      const byteCharacters = atob(b64Data)
      const byteNumbers = new Array(byteCharacters.length)
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i)
      }
      const byteArray = new Uint8Array(byteNumbers)
      const blob = new Blob([byteArray], { type: 'application/pdf' })
      const b64toBlob = (b64Data, contentType = 'application/pdf', sliceSize = 512) => {
        const byteCharacters = atob(b64Data)
        const byteArrays = []

        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
          const slice = byteCharacters.slice(offset, offset + sliceSize)

          const byteNumbers = new Array(slice.length)
          for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i)
          }

          const byteArray = new Uint8Array(byteNumbers)
          byteArrays.push(byteArray)
        }

        const blob = new Blob(byteArrays, { type: 'application/pdf' })
        return blob
      }
      var blob1 = b64toBlob(b64Data, 'application/pdf')
      var blobUrl = URL.createObjectURL(blob1)
      var win = window.open(blobUrl, '_blank')
      window.document.name = this.invoice_no
    },
    async getperioddetails () {
      try {
        if (this.currentsvnumber && this.currentstart_date && this.currentend_date) {
          var { data: data1 } = await this.axios.post(process.env.VUE_APP_APIHOST + '/sv_list', {
            sv_number: this.currentsvnumber,
            start_date: this.currentstart_date,
            end_date: this.currentend_date
          })
          this.nameserviceSelected = data1[0].services_type
          this.svdetail = data1
          this.summarydetail = data1[0]
          this.invoice_no = this.summarydetail.invoice_no
          this.sumtotalprice()
          this.dialogloader = false
        }
      } catch (error) {
        this.istableloading = false
        console.log(error.message)
      }
    },
    addCommas (nStr) {
      nStr += ''
      var x = nStr.split('.')
      var x1 = x[0]
      var x2 = x.length > 1 ? '.' + x[1] : ''
      var rgx = /(\d+)(\d{3})/
      while (rgx.test(x1)) {
        x1 = x1.replace(rgx, '$1' + ',' + '$2')
      }
      return x1 + x2
    },
    handleView () {
      this.mobileView = window.innerWidth <= 990
      this.$cookies.set('screenView', this.mobileView)
    },
    sumtotalprice () {
      this.sub_total =
        this.svdetail
          .reduce(function (p, n) {
            return (
              p +
              n.sv_amount_exclude_vat
            )
          }, 0),
      this.vat_amount =
        this.svdetail
          .reduce(function (p, n) {
            return (
              p +
              n.vat_amount
            )
          }, 0)
    }
  },
  computed: {
    periodmodal: sync('periodmodal'),
    prepaidmodal: sync('prepaidmodal'),
    currentsvnumber: sync('currentsvnumber'),
    currentstart_date: sync('currentstart_date'),
    currentend_date: sync('currentend_date'),
    itemlistview () {
      return this.svdetail.map(item => {
        return {
          ...item
          // grand_total: item.sv_amount_exclude_vat + item.vat_amount
        }
      })
    },
    // detailview () {
    //   return Object.keys(this.svdetail)
    //     .filter(
    //       key =>
    //         ![
    //           'so_number',
    //         ].includes(key)
    //     )
    //     .reduce((obj, key) => {
    //       obj[key] = this.invoicedatail[key]
    //       return obj
    //     }, {})
    // },
    paymenturl () {
      return process.env.VUE_APP_PAYMENTURL
    }
  },
  watch: {
    currentstart_date () {
      this.getperioddetails()
    }
  },
  created () {
    this.getperioddetails()
    this.dialogloader = false
    this.handleView()
  }
}
</script>

<style>
#tableDetail tr:nth-child(even){
    background-color: #f1fcf1;
  }
/* responsive */
@media(max-width: 500px){
  #tableDetail thead{
    display: none;
}
  #tableDetail tr:nth-child(even){
    background-color: #f1fcf1;
  }
  #tableDetail, #tableDetail tr, #tableDetail td{
    display: block;
    width: 100%;
  }
  #tableDetail tr, #tableDetail td{
    border:1px solid #ddd;
    text-align: center;
  }
  #tableDetail tr{
    margin-bottom: 15px;
  }
  #tableDetail td{
    overflow-wrap : break-word;
    display: inline-block;
    word-break: break-word;
    text-align: right;
    padding-left: 50%;
    position: relative;
    height:50px;
  }
   #tableDetail td.longtext{
     min-height: 40px;
     height:fit-content;
     word-break: break-word;
  }
  #tableDetail td::before{
    content: attr(data-label);
    position: absolute;
    left: 0;
    width: 40%;
    padding-left: 15px;
    font-size: 15px;
    font-weight: bold;
    text-align: left;
  }
}

</style>
